// ZAL10-OPTION-FIELD-1 (2026-10-04): the OPTIONAL `option` string on a diagram
// hotspot (bot service 5004, `GET /api/v1/diagram/{page}/hotspots`) — the
// option label as printed on the schematic, e.g. "OPTION CHIP CONVEYOR".
//
// Contract (machineid-bot-integration MACHINEID_TODO.md, bot `39c3328`): ABSENT
// for standard equipment; at most 80 characters, no control characters and
// none of < > " ' ` — sanitised bot-side. We do not rely on that: the value is
// raw wire data, so it is re-checked here before the info card shows it.
//
//   non-string / empty / whitespace-only -> null (no "Option:" line)
//   otherwise -> trimmed, capped to 80 characters (code points, so a capped
//                value never ends in half a surrogate pair)
//
// Rendering is plain text ONLY (a React text node in DiagramInfoCardV2) —
// never innerHTML / dangerouslySetInnerHTML / markdown (SEC-REQ-5).

/** Maximum characters of `option` shown — same cap as the bot's check. */
export const HOTSPOT_OPTION_MAX_CHARS = 80;

export const normalizeHotspotOption = (raw: unknown): string | null => {
  if (typeof raw !== "string") return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const chars = Array.from(trimmed);
  if (chars.length <= HOTSPOT_OPTION_MAX_CHARS) return trimmed;
  return chars.slice(0, HOTSPOT_OPTION_MAX_CHARS).join("").trimEnd();
};
